import Hub from ".";

export const hubRoute = (data) => {
  return [
    {
      path: "/:lang/profile",
      title: "Hub",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: Hub,
    },
  ];
};
